// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const UnoLeftNavContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-leftnav" */ "./UnoLeftNavContainer")).then((bundle)=>{
        return {
            default: bundle.UnoLeftNavContainer
        };
    });
export const LazyUnoLeftNavContainer = /*#__PURE__*/ lazy(UnoLeftNavContainerLazyLoader);
